import type { Prototype } from "../prototype-types";

export const jackGuoPrototypes: Prototype[] = [
  {
    id: "jg-pricing-parity-msrp-initial-review",
    name: "Pricing Parity MSRP Initial Review Admin Queue",
    path: "/jg/pricing-parity-msrp-initial-review",
    description: "Admin queue mockup for reviewing MSRP violations on brand websites — mirrors the direct WSP queue with a new Price found column.",
    owner: "Jack Guo",
    createdAt: "2026-05-10",
    lastUpdated: "2026-05-10",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/6ab6754d03d0da364ff8e9bd1d61aeb187fd5850d5cab854cd1d32c2653c6c26.png",
    creationTool: "claude-code",
  },
  {
    id: "jg-pricing-parity-msrp-qa",
    name: "Pricing Parity MSRP QA Admin Queue",
    path: "/jg/pricing-parity-msrp-qa",
    description: "Admin queue mockup for QA review of MSRP violations on brand websites — mirrors the direct WSP QA queue with a Price found column and per-row Pass&#x2F;Fail decisions.",
    owner: "Jack Guo",
    createdAt: "2026-05-11",
    lastUpdated: "2026-05-11",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/0574b8c9edbc36e81b6d88cd7f58b799705ad664db8223c5c77518d060fd9655.png",
    creationTool: "claude-code",
  },
  {
    id: "jg-pricing-parity-msrp-audit-queue",
    name: "Pricing Parity MSRP Review Audit Queue",
    path: "/jg/pricing-parity-msrp-audit-queue",
    description: "Admin queue mockup for MSRP review audits — list of brand audits with drill-down into per-brand reviewed-products tables.",
    owner: "Jack Guo",
    createdAt: "2026-05-11",
    lastUpdated: "2026-05-11",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/9938f9f497b124f22e83695ea8280bce96fdb762f66f114e93ab5d04e2ee6399.png",
    creationTool: "claude-code",
  },
  {
    id: "jg-pricing-parity-msrp-appeals-queue",
    name: "Pricing Parity MSRP Appeals Queue",
    path: "/jg/pricing-parity-msrp-appeals-queue",
    description: "Admin mockup for MSRP appeals — brand admin appeals tab with a per-brand appeals list and per-appeal product details view.",
    owner: "Jack Guo",
    createdAt: "2026-05-11",
    lastUpdated: "2026-05-11",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail: "https://cdn.prerelease.faire.dev/fastly/6004420d1ddf7c00c747d6db66a569e251d60daf6f953ea8ea73e5b9f622972a.png",
    creationTool: "claude-code",
  }
];
